import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, of, tap } from 'rxjs';
import { DataService } from 'src/app/shared/services/data/data.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { DashboardUser } from './auth-user.model';
import { UsersService } from '../features/users/users.service';

const endPoint = 'admin';
@Injectable({
  providedIn: 'root',
})
export class AuthService extends DataService {
  constructor(
    http: HttpClient,
    private storageService: StorageService,
    private usersService: UsersService,
    private router: Router
  ) {
    super(endPoint, http);
  }

  login(credential: {
    username: string;
    password: string;
  }): Observable<DashboardUser> {
    return this.post('login', credential).pipe(
      map((data: { user: DashboardUser }) => data.user),
      tap((user: DashboardUser) => this.setUser(user))
    );
  }

  logout(): Observable<void> {
    return this.post('logout', '').pipe(tap(() => this.removeUser()));
  }

  isLoggedIn(): Observable<boolean> {
    const user = this.getUser();

    if (this.router.url === '/login') {
      if (user) return of(true);
    } else if (user) {
      return this.usersService.get('').pipe(map((data) => !!data));
    }

    return of(false);
  }

  getUser(): DashboardUser | null {
    return (this.storageService.get('user') as DashboardUser) || null;
  }

  getUserToken(): string {
    const user = this.getUser();
    return user ? user.access_token : '';
  }

  private setUser(user: DashboardUser): void {
    console.log(this.storageService);
    this.storageService.set('user', user);
  }

  private removeUser(): void {
    this.storageService.remove('user');
  }
}
